import { Form, Table, message } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import 'src/assets/css/ReactDataTable.css'
import 'src/assets/css/AdminConfiguration.css'
import { CSVLink } from "react-csv"
import { useDispatch } from 'react-redux';
import { showSuccessNotification, showErrorNotification, showInfoNotification } from 'src/animation/notificationUtils';
import {
    GetColumns, GetFilterList, HandleRefresh,
    handleResize, handleDependent, handleAdd, ResizeableTitle, EditableCell, save
} from 'src/views/components/ReactDataTableComponents'
import { useSelector } from 'react-redux';
import DownloadIcon from "src/assets/images/download_selected.png"
import addIcon from "src/assets/images/add.svg"
import cancelIcon from "src/assets/images/cancel.svg"
import BackIcon from "src/assets/images/left_arrow.png"
import refreshIcon from "src/assets/images/refresh.png"
import saveIcon from "src/assets/images/save.png"

const ReactDataTable = (props) => {

    const [form] = Form.useForm();
    const [uniqueKey, setuniqueKey] = useState('')
    const [data, setData] = useState([])
    const [OriginalData, setOriginalData] = useState([])
    const [RowAdded, setRowAdded] = useState(false)
    const [headers, setHeaders] = useState([])
    const [columns, setColumns] = useState([])
    const [dependent, setDependent] = useState({})
    const [UpdatedColumnKeys, setUpdatedColumnKeys] = useState([])
    const [DeletedColumnKeys, setDeletedColumnKeys] = useState([])
    const [menuItems, SetmenuItems] = useState([]);
    const [TotalList, setTotalList] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [FilterObject, setFilterObject] = useState({})
    const [TableKey, setTableKey] = useState(1)
    const [loading, setLoading] = useState(false)
    const [openFile, setOpenFile] = useState(false)


    let PROPS = {
        ...props,
        form,
        uniqueKey, setuniqueKey,
        data, setData,
        OriginalData, setOriginalData,
        RowAdded, setRowAdded,
        headers, setHeaders,
        columns, setColumns,
        dependent, setDependent,
        UpdatedColumnKeys, setUpdatedColumnKeys,
        DeletedColumnKeys, setDeletedColumnKeys,
        menuItems, SetmenuItems,
        TotalList, setTotalList,
        currentPage, setCurrentPage,
        FilterObject, setFilterObject,
        TableKey, setTableKey,
        loading, setLoading,
        openFile, setOpenFile,
        showSuccessNotification, setDeletedColumnKeys,
        showErrorNotification, showInfoNotification
    }

    useEffect(() => {
        GetColumns(data, PROPS)
    }, [RowAdded]);


    useEffect(() => {
        if (!props.tableRecord) {
            showErrorNotification("Failed to fetch records. Please try again later.")
            GetColumns([], PROPS)
        } else {
            const data = props.tableRecord.map((obj, index) => {
                let record = {}
                record['key'] = index
                Object.entries(obj).forEach(([key, value]) => {
                    if (props.fieldsToShow[key] && props.fieldsToShow[key]['selectMode'] == "multiple" && value) {
                        const cleanedString = value.replace(/\\/g, '');
                        record[key] = JSON.parse(cleanedString)

                    } else {
                        if (props.fieldsToShow[key]) {
                            if (props.fieldsToShow[key]['selectMode'] == "multiple") {
                                record[key] = []
                            } else {
                                record[key] = value ? value + "" : value
                            }
                        } else {
                            record[key] = value
                        }
                    }

                    if (props.fieldsToShow[key] && props.fieldsToShow[key]['parent']) {
                        handleDependent(obj[props.fieldsToShow[key]['parent']], props.fieldsToShow[key]['parent'], PROPS)
                    }

                })
                return record
            })


            setData(data)
            setuniqueKey(data.length)
            setOriginalData(data)
        }

        var HeaderForCSV = []


        Object.entries(props.fieldsToShow).forEach(([k, v], index) => {
            HeaderForCSV.push({ label: v.label, key: k })
        })

        setHeaders(HeaderForCSV)
    }, [])

    useEffect(() => {
        GetColumns(data, PROPS);
    }, [data, dependent, menuItems, TotalList, currentPage, FilterObject])

    useEffect(() => {
        Object.entries(props.fieldsToShow).forEach(([key, value]) => {
            let customFilterData = value['selectMode'] == "multiple" ? [] : value['remote-source'] ? GetFilterList(OriginalData, key, value['remote-source'], PROPS) : GetFilterList(OriginalData, key, {}, PROPS)
            SetmenuItems((prev) => { return { ...prev, [key]: customFilterData } })
            setTotalList((prev) => { return { ...prev, [key]: customFilterData } })
            setCurrentPage((prev) => { return { ...prev, [key]: 1 } })
        })
    }, [dependent, data])

    const mergedColumns = columns.map((col, index) => {
        const { permission, tabname } = props;
        if (!col.editable) {
            return {
                ...col,
                onCell: (record) => ({
                    record,
                    inputType: col.type,
                    dataIndex: col.dataIndex,
                    selectMode: col.selectMode,
                    required: col.required,
                    remoteSource: col.remoteSource,
                    title: col.title,
                    openFile: openFile,
                    colorSetField: col.colorSetField,
                    setOpenFile: setOpenFile,
                    source: col.source,
                    Key: record['key']
                }),
                onHeaderCell: (column) => ({
                    width: column.width,
                    onResize: handleResize(index, PROPS)
                })
            }
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.type,
                dataIndex: col.dataIndex,
                handleDependent,
                selectMode: col.selectMode,
                required: col.required,
                remoteSource: col.remoteSource,
                title: col.title,
                min: col.min,
                max: col.max,
                colorSetField: col.colorSetField,
                source: col.source,
                Key: record['key'],
                openFile: openFile,
                setOpenFile: setOpenFile,
                editing: true,
                props: PROPS
            }),
            onHeaderCell: (column) => ({
                width: column.width,
                onResize: handleResize(index, PROPS)
            })
        };
    });

    const onFinish = (values) => {
        console.log('Form values:', values);
    }

    return (
        <div>
            <div  style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" , paddingInline:"20px" , paddingBlock:"5px" }}>
  
                    {/* <button
                        type="primary"
                        className='save_button'
                        onClick={() => {
                                window.history.back();
                            }}
                        >
                            //BackIcon
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> &nbsp;Back</button>  */}
                    <div>
                        <div className='back_custom_tooltip'>
                            <img style={{ marginTop: '2px', marginLeft: '2px' }} onClick={() => { window.history.back(); }}
                                src={BackIcon} height="31" width="31"></img>
                            <span class="tooltiptext" >Back</span>
                        </div>
                    </div>



                    {/* <button
                            onClick={() => { RowAdded ? handleAdd("Cancel Add") : handleAdd("AddRow") }}
                            type="primary"
                            className='save_button'>
                            {RowAdded ? (
                                <>
                                    <img src={cancelIcon} height={30} width={30}></img>
                                </>
                            ) : (
                                <>
                                   <img src={addIcon} height={30} width={30}></img>
                                </>
                            )
                            }
                        </button> */}
                

                <div>


                    <div className='custom_tooltip' style={{ paddingLeft: "5px" }}>
                        <img onClick={() => { RowAdded ? handleAdd("cancel Add", PROPS) : handleAdd("AddRow", PROPS) }}
                            src={RowAdded ? cancelIcon : addIcon} height={RowAdded ? 35 : 35} width={RowAdded ? 35 : 35}></img>
                        <span className="tooltiptext" >{RowAdded ? 'Cancel' : 'Add New'}</span>
                    </div>

                    &nbsp;

                    <div className='custom_tooltip' style={{ paddingLeft: "5px" }}>
                        <img onClick={() => { HandleRefresh(PROPS) }}
                            src={refreshIcon} height={30} width={30}></img>
                        <span className="tooltiptext" >{'Refresh'}</span>
                    </div>

                    &nbsp;

                    <div className='custom_tooltip' style={{ paddingLeft: "5px" }}>
                        <img onClick={() => { save(PROPS) }}
                            src={saveIcon} height={30} width={30}></img>
                        <span className="tooltiptext" >{'Save'}</span>
                    </div>

                    &nbsp;

                    <CSVLink className='csv_custom_tooltip' style={{ paddingLeft: "5px" }} data={data} headers={headers} filename={"KPI_Dashboard.csv"} >
                        
                        <img src={DownloadIcon} height={30} width={30}  ></img>
                        <span className="tooltiptext" >Download CSV</span>
                    </CSVLink>
                </div>
            </div>


            <Form form={form} component={false} onFinish={onFinish} >
                <Table
                    bordered
                    dataSource={data}
                    expandable={true}
                    loading={loading}
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                        header: {
                            cell: ResizeableTitle
                        }
                    }}
                    fixed
                    scroll={{ y: "77.5vh" , x: 1600  }}
                    columns={mergedColumns}
                    showSorterTooltip={false}
                    rowClassName="editable-row"
                    pagination={{ position: ['none', 'bottomLeft'], defaultPageSize: 20 }}
                    size="small"
                />
            </Form>

        </div>
    );
};
export default ReactDataTable;


